import React from 'react'
import { connect } from 'react-redux'
import Notices from './Notices'
import SubBands from './SubBands'
import SubDiscounts from './SubDiscounts'

class Community extends React.Component {

  render() {

    return (
      <div id="community">
        <h1>4ZZZ Community</h1>
        <div id="supporters">
          <h2>Supporters and Sub Discounts</h2>
          <SubDiscounts />
        </div>
        <div id="subbands">
          <h2>Sub Bands</h2>
          <SubBands />
        </div>
      </div>
    )
  }
}

export default connect(state => ({})) (Community)
